<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" persistent @keydown.esc="dialogCerrar = true">
      <v-card v-if="dialog">
        <v-toolbar flat dark color="primary">
          <v-btn icon dark @click="dialogCerrar = true">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{timer.cliente}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="accionAlImputar" 
              :disabled="this.$v.horasInformadas.$invalid || this.$v.comentariosFD.$invalid || this.$v.idParteSeleccionado.$invalid || this.timer.invalido == true || this.$v.contratoSeleccionado.$invalid || this.$v.ambito.$invalid"
            >
              Imputar
            </v-btn>
          </v-toolbar-items>
          <!-- <v-menu bottom right offset-y></v-menu> -->
        </v-toolbar>
        <v-card-text>
          <v-alert
            class="mt-4"
            dense
            outlined
            border="left"
            type="error"
            icon="mdi-close-circle-outline"
            v-if="(this.$refs.resumen && this.$refs.resumen.estadoContrato() === 'critico') || esMoroso === 'critico'"
          >
            {{timer.cliente}} tiene contratos en negativo que se encuentran por encima del umbral máximo
          </v-alert>
          <v-alert
            class="mt-4"
            dense
            outlined
            border="left"
            type="info"
            icon="mdi-alert-circle-outline"
            v-if="(this.$refs.resumen && this.$refs.resumen.estadoContrato() === 'leve') || esMoroso === 'leve'"
          >
            {{timer.cliente}} tiene contratos en negativo
          </v-alert>
          <v-card elevation="2" class="mt-4">
            <v-card-title>Detalles de la acción</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-dialog ref="dialogFecha" v-model="modalFecha" :return-value.sync="fecha" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field 
                        v-model="fechaFormateada" 
                        prepend-icon="mdi-calendar" 
                        label="Fecha" v-bind="attrs" 
                        v-on="on" 
                        @blur="fecha = parseDate(fechaFormateada)" 
                        readonly
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="fecha" scrollable :first-day-of-week="1" :max="dateToYMD(new Date())">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modalFecha = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.dialogFecha.save(fecha)">Aceptar</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" sm="4" md="2">
                  <v-dialog ref="dialogHoraInicio" v-model="modalHoraInicio" :return-value.sync="timer.inicioTimerFD" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="timer.inicioTimerFD" label="Inicio" prepend-icon="mdi-clock-outline" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-time-picker v-if="modalHoraInicio" v-model="timer.inicioTimerFD" format="24hr" full-width>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modalHoraInicio = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.dialogHoraInicio.save(timer.inicioTimerFD), calcularTiempoTotal()">Aceptar</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" sm="4" md="2">
                  <v-dialog ref="dialogHoraFin" v-model="modalHoraFin" :return-value.sync="timer.finTimerFD" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }"> 
                      <v-text-field v-model="timer.finTimerFD" label="Fin" prepend-icon="mdi-clock-outline" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-time-picker v-if="modalHoraFin" v-model="timer.finTimerFD" format="24hr" full-width>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modalHoraFin = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.dialogHoraFin.save(timer.finTimerFD), calcularTiempoTotal()">Aceptar</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                      <v-text-field variant="underlined" label="Horas reales"
                        v-model.number="horasReales" type="number" readonly
                        :hint="decimalToHHMM(horasReales)" persistent-hint
                      />
                  </v-col>
                  <v-col cols="12" sm="2" md="2">
                      <v-text-field variant="underlined" label="Horas informadas" class="anadirAsterisco"
                        v-model.number="horasInformadas" type="number" step="0.25" min="0"
                        :hint="decimalToHHMM(horasInformadas)" persistent-hint
                        @input="$v.horasInformadas.$touch()" @blur="$v.horasInformadas.$touch()" :error-messages="errorHorasInformadas"
                      />
                  </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea 
                    class="mx-2 anadirAsterisco"
                    label="Comentarios" 
                    v-model="comentariosFD"  
                    prepend-icon="mdi-playlist-star"
                    @click:prepend="dialogComentariosGuardados = true"
                    @input="$v.comentariosFD.$touch()" 
                    @blur="$v.comentariosFD.$touch()"
                    :error-messages="errorComentarios"
                    :disabled="this.timer.invalido == true"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card elevation="2" class="mt-4">
            <v-card-title>Contratos y ámbitos</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" md="3">
                  <v-select 
                    :items="contratosActivos" 
                    item-text="contrato" 
                    item-value="id" 
                    label="Contrato" 
                    v-model="contratoSeleccionado"
                    return-object
                    @change="verificarSiContieneContrato()"
                    @input="$v.contratoSeleccionado.$touch()" 
                    @blur="$v.contratoSeleccionado.$touch()"
                    :error-messages="errorContratoSeleccionado"
                    class="anadirAsterisco"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-select 
                    :items="contratoSeleccionado.ambitos" 
                    item-text="ambito" 
                    item-value="id" 
                    label="Ámbito" 
                    v-model="ambito"
                    @input="$v.ambito.$touch()" 
                    @blur="$v.ambito.$touch()"
                    :error-messages="errorAmbito"
                    class="anadirAsterisco"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-select :items="gradosurgencia" item-text="urgencia" item-value="id" label="Urgencia" v-model="gradourgencia"
                    :hint="gradourgencia.comentarios" persistent-hint return-object></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" block outlined>Más opciones</v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-title class="px-2">
                        <v-checkbox class="mb-2" hide-details label="Desplazamiento" v-model="masOpciones.desplazamiento" @change="comprobarTiempo($event)"></v-checkbox>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title class="px-2">
                        <v-checkbox class="mb-2" hide-details label="Asistencia mínima" v-model="masOpciones.asistencia_minima"></v-checkbox>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="authUser.isAdmin || authUser.isAdmon">
                      <v-list-item-title class="px-2">
                        <v-checkbox class="mb-2" hide-details label="Abono" v-model="masOpciones.abono"></v-checkbox>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title class="px-2">
                        <v-checkbox class="mb-2" hide-details label="APV" v-model="masOpciones.apv"></v-checkbox>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              </v-row>
              <v-alert
                dense
                outlined
                border="left"
                type="info"
                icon="mdi-information-outline"
                v-if="restriccionContrato == true"
              >
                El parte seleccionado tiene restricción de contrato, por lo que no están disponibles todos los contratos
              </v-alert>
            </v-card-text>
          </v-card>     

          <v-card elevation="2" class="mt-4">
            <v-card-title>
              <v-text-field v-model="search" append-icon="mdi-file-search-outline" label="Buscar" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="partes" :search="search">
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Parte</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" outlined @click="comprobarDatos()" :disabled="!botonNuevoParte">
                    Nuevo parte <v-icon right dark>mdi-plus</v-icon>
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:item.seleccion="{ item }">
                <v-radio-group v-model="idParteSeleccionado">
                  <v-radio :value="item.id"></v-radio>
                </v-radio-group>
              </template>
              <template v-slot:item.categorias="{ item }">
                <v-chip
                  v-for="categoria in item.categorias"
                  :key="categoria.id"
                  :color="categoria.color"
                  outlined small label
                >
                  {{ categoria.name }}
                </v-chip>
              </template>
              <template v-slot:item.user.name="{ item }">
                  <v-chip outlined>
                      <v-avatar left :color="item.user.color">
                          <span class="white--text">
                              {{ item.user.avatar }}
                          </span>
                      </v-avatar>
                      {{ item.user.name+' '+item.user.apellidos}}
                  </v-chip>
              </template>
              <template v-slot:item.realizar="{ item }">
                <v-textarea v-model="item.realizar" readonly hide-details rows="1"></v-textarea>
              </template>
              <template v-slot:item.acciones="{ item }"> <!-- Solo muestra los iconos si es el nuevo parte-->
                <v-icon v-if="esNuevo(item.id)" class="mr-2" @click="dialogCrearEditarParte= true">mdi-pencil</v-icon>
                <v-icon v-if="esNuevo(item.id)" @click="eliminarParte()">mdi-delete</v-icon>
              </template>
            </v-data-table>
          </v-card>   
          <ResumenCliente
            class="mt-4"
            :loading="loadingEstadoContratos"
          />
        </v-card-text>
      </v-card>
      <v-row justify="center">
        <v-dialog v-model="dialogCrearEditarParte" max-width="500px" persistent>
          <v-card>
            <v-card-title><span class="headline">{{ tituloDialog() }}</span></v-card-title>
            <v-card-text>
              <v-row class="mt-2" dense>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="parteCreado"
                    :items="tecnicos"
                    chips
                    label="Técnico asignado"
                    item-text="name"
                    item-value="id"
                    return-object
                  >
                    <template v-slot:selection="data">
                      <v-chip v-bind="data.attrs" :input-value="data.selected" @click="data.select">
                        <v-avatar left :color="data.item.color">
                          <span class="white--text">{{ data.item.avatar }}</span>
                        </v-avatar>
                        {{ data.item.name }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-avatar :color="data.item.color">
                          <span class="white--text">{{ data.item.avatar }}</span>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                          <v-list-item-subtitle>{{ data.item.apellidos }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-text-field 
                    v-model="concepto" 
                    label="Concepto" 
                    maxlength="35" 
                    counter
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12">
                  <v-textarea label="A realizar" v-model="aRealizar"/>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="cancelarCrearEditarParte()">Cancelar</v-btn>
              <v-btn color="blue darken-1" text :disabled="this.$v.parteCreado.$invalid || this.$v.aRealizar.$invalid" @click="crearEditarParte()">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <v-row justify="center">
        <v-dialog v-model="dialogCerrar" persistent max-width="380">
          <v-card>
            <v-card-title class="headline">¡Atención!</v-card-title>
            <v-card-text>Vas a salir sin guardar los cambios. ¿Estás seguro?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogCerrar = false">Cancelar</v-btn>
              <v-btn color="error" text @click="cerrar">Salir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <v-row justify="center">
        <ComentariosGuardados 
          :dialogComentariosGuardados="dialogComentariosGuardados" 
          @close="dialogComentariosGuardados = false"
          @aceptar="insertarComentario"
        />
        <v-dialog v-model="dialogAvisoMateriales" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">Recordatorio</v-card-title>
            <v-card-text>
              <ul>
                <li>
                  Estás imputando una acción con desplazamiento, de haber utilizado materiales, recuerda ir al apartado de materiales para añadirlos.
                </li>
                <li>
                  El desplazamiento que has marcado se ha asociado a la delegación indicada en el parte:
                  <center>
                    <h3>{{ delegacionParteSeleccionado }}</h3>
                  </center>
                </li>
              </ul>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogAvisoMateriales = false; imputar()">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-dialog>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import { required } from 'vuelidate/lib/validators';
  import axios from 'axios';
  axios.defaults.baseURL = process.env.VUE_APP_API_URL;
  import uuidv4 from '../../mixins/uuidv4';
  import formatearFecha from '../../mixins/formatearFecha';
  import ResumenCliente from "../resumen/resumenCliente.vue"
  import ComentariosGuardados from '../comentariosGuardados/ComentariosGuardados.vue'
  import { calcularHorasReales } from '@/composables/calcularHoras.js'

  export default {
    name: 'FullDialog',
    components: {
      ResumenCliente, ComentariosGuardados
    },
    mixins: [uuidv4, formatearFecha],
    props: ['timerContainer', 'partesContainer', 'tecnicos', 'contratosContainer', 'ambitos', 'gradosurgencia', 'comerciales', 'delegaciones'],
    data: vm=> ({
      timer: {},
      contratos: [],
      partes: [],
      fechaFormateada: vm.formatDate(new Date().toISOString().substr(0, 10)),
      fechaHoy: new Date().toISOString().substr(0, 10),
      fecha: null,
      dialogCerrar: false,
      idParteSeleccionado: '',
      comentariosFD: '',
      horasInformadas: null,
      contratoSeleccionado: {
        ambitos: []
      },
      gradourgencia: null,
      ambito: 5,
      masOpciones:{
        desplazamiento: false,
        asistencia_minima: false,
        abono: false,
        apv: false,
      },
       
      botonNuevoParte: true,
      dialogCrearEditarParte: false,
      parteCreado:{},
      concepto: 'Tareas varias',
      aRealizar: 'Tareas varias',

      modalFecha: false,
      modalHoraInicio: false,
      modalHoraFin: false,
      search: '',
      loading: false,
      headers: [
        {
          text: '',
          filterable: false,
          sortable: false,
          value: 'seleccion',
          width: '70px'
        },
        {
          text: 'Núm. Parte',
          filterable: true,
          value: 'numParte',
          width: '120px'
        },
        {
          text: 'Concepto',
          filterable: true,
          value: 'concepto',
          width: '140px'
        },
        {
          text: 'Categorías',
          filterable: true,
          value: 'categorias',
          width: '100px'
        },
        {
          text: 'Técnico',
          filterable: true,
          sortable: true,
          value: 'user.name',
          width: '220px'
        },
        {
          text: 'A realizar',
          filterable: false,
          sortable: false,
          value: 'realizar'
        },
        { 
          text: '',
          filterable: false,  
          sortable: false,
          value: 'acciones',
          width: '100px'
        },
      ],
      
      idComercialReferencia: null,
      restriccionContrato: false,
      dialogAvisoMateriales: false,
      loadingEstadoContratos: true,
      dialogComentariosGuardados: false
    }),
    validations: {
      contratoSeleccionado: {required},
      ambito: {required},
      comentariosFD: { required },
      idParteSeleccionado: { required },
      parteCreado: { required },
      aRealizar: { required },
      horasInformadas: { required },
    },
    created() {
      this.inicializarDatos();
    },
    async mounted(){
      let codCliente = this.timer.idCliente;
      await this.getEstadoContratosCliente([this.fechaHoy, codCliente]);
      this.loadingEstadoContratos = false;
    },
    methods: {
      ...mapActions(['setLoading', 'setSnackbar']),
      ...mapActions('arditimer', ['setDialog', 'setEliminarTimer', 'setIdTimerActivo', 'setImputarTodos', 'setCargarDatosDialog', 'setTimer', 'setRestarCantidadTimersTotal']),
      ...mapActions('contratos', ['getEstadoContratosCliente', 'setContratosCliente']),
      async inicializarDatos(){
        this.timer = JSON.parse(JSON.stringify(this.timerContainer));
        this.partes = JSON.parse(JSON.stringify(this.partesContainer));
        this.contratos = JSON.parse(JSON.stringify(this.contratosContainer));
        
        if(this.contratos.length <= 3){ //Si solo tiene los contratos que no son de bolsa marcamos por defeto el facturable
          this.contratoSeleccionado = this.contratos.find(contrato => contrato.id === 9);
        }else { //sino marcamos el de arriba del todo
          // this.contrato = this.contratos[0].id;
          this.contratoSeleccionado = this.contratos[0];
        }
        this.fecha = this.timer.fechaFD;
        this.comentariosFD = this.timer.comentariosFD;
        this.idParteSeleccionado = this.timer.parteInicial;
        this.parteCreado = this.tecnicos.filter(t => t.name == "GENERAL")[0];
        this.gradourgencia = this.gradosurgencia.find(g => g.id === 4) //por defecto el grado de urgencia es normal
      },
      async imputar(){
        this.setLoading(true);
        try{
          let accion = {
            idParte: this.idParteSeleccionado,
            fecha: this.fecha,
            entrada: this.timer.inicioTimerFD,
            salida: this.timer.finTimerFD,
            horasInformadas: this.horasInformadas,
            comentarios: this.comentariosFD,
            contrato: {id: this.contratoSeleccionado.id},
            ambito: {id: this.ambito},
            urgencia: {id: this.gradourgencia.id},
            desplazamiento: this.masOpciones.desplazamiento,
            abono: this.masOpciones.abono,
            asistencia_minima: this.masOpciones.asistencia_minima,
            apv: this.masOpciones.apv
          };
          
          if(accion.entrada.substr(0, 2) > accion.salida.substr(0, 2)){
            accion.entrada = '00:00'
            accion.salida = this.timer.tiempoTotalFD
            
            //Pasamos de dia
            var f = new Date(accion.fecha);
            f.setDate(f.getDate() + 1);
            accion.fecha = f.toISOString().substr(0, 10);
          }

          //SI PARTE.ID = 'NUEVO' --> SE TIENE QUE CREAR EL PARTE
          if(this.esNuevo(this.idParteSeleccionado)){
            // if(this.delegaciones == []){
            //   let respuesta = await axios.get(`/api/delegaciones?codCliente=${this.timer.idCliente}`);
            //   this.delegaciones = respuesta.data;
            // }

            let parteNuevo = {
              cliente_id: this.timer.idCliente,
              cliente: this.timer.cliente,
              user_id: this.parteCreado.id,
              comercial_id: this.idComercialReferencia,
              responsable_id: this.responsable_id,
              concepto: this.concepto,
              realizar: this.aRealizar,
              fecha: new Date().toISOString().substr(0, 10),
              inicio: this.formatearHora(new Date()),
              fechaVto: null,
              delegacion_id: this.delegaciones[0].delegacionId,
              fidelizar: 0,
              estadoParte_id: 1,
              acciones: [accion]
            }
            let respuesta = await axios.post('/api/partes', parteNuevo);
            let parteCreado = respuesta.data;
            this.idParteSeleccionado = parteCreado.id;
          }else{
            await axios.post("/api/acciones", accion); //guardar accion
          }
          
          await axios.delete('/api/arditimers/'+ this.timer.id) //eliminar timer
          this.setEliminarTimer(this.timer);

          this.setLoading(false);
          this.setSnackbar({
            tipo: 'success',
            mensaje: 'Acción imputada correctamente'
          });
        }catch(error){ 
          this.setLoading(false);
          this.setSnackbar({
            tipo: 'error',
            mensaje: 'Error. No se ha podido guardar la acción'
          });
        };

        if(this.imputarTodos === true){
          delete this.timer;
          this.timers.forEach(timer => {
            if (timer.hora > 0 || timer.minuto > 5){
              this.timer = timer;
              this.setIdTimerActivo(timer.id);
            }
          });
          if(this.timer){
            this.comentariosFD = '';
            this.ambito = 5;
            this.gradourgencia = this.gradosurgencia.find(g => g.id === 4); //urgencia normal
            this.masOpciones.desplazamiento = false;
            this.masOpciones.asistencia_minima = false;
            this.masOpciones.abono = false;
            this.masOpciones.apv = false;
            this.$v.$reset();
            this.setIdTimerActivo(this.timer.id);
            this.siguienteImputarTodos();
          }else{
            this.setImputarTodos(false);
            this.cerrar();
          }
        }else{
          this.cerrar();
        }
      },
      cerrar(){
        this.setDialog(false);
        this.$v.$reset();
        this.setIdTimerActivo('');
      },
      formatDate (fecha) { //cambiamos el formato de la fecha de YYYY-MM-DD a DD/MM/YYYY
        const [year, month, day] = fecha.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (fecha) { //cambiamos el formato de la fecha de DD/MM/YYYY a YYYY-MM-DD
        const [day, month, year] = fecha.split('/')
        return `${year}-${month}-${day}`//`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      tituloDialog(){
        return this.botonNuevoParte? 'Nuevo parte' : 'Editar parte' //depende de si el dialogo se utilizará para crear el parte o editarlo pongo un titulo u otro
      },
      crearEditarParte(){
        if (this.botonNuevoParte){ //si aún no se ha creado el parte lo crea
          this.idParteSeleccionado= this.uuidv4();
          // console.log(this.parteCreado);
          this.partes.unshift({
            id: this.idParteSeleccionado,
            user: this.parteCreado,
            concepto: this.concepto,
            realizar: this.aRealizar
          });
        }else{ //en caso de que ya exista lo edita
          this.partes[0].user= this.parteCreado;
          this.partes[0].concepto= this.concepto;
          this.partes[0].realizar= this.aRealizar;
        }
        this.dialogCrearEditarParte= false; //cierro el dialogo 
        this.botonNuevoParte= false; //desactivo el boton
      },
      cancelarCrearEditarParte(){
        this.dialogCrearEditarParte= false; //cierro el dialogo
        if (this.botonNuevoParte){ //si se cierra la ventana de nuevo parte ponemos los valores vacios
          this.parteCreado = this.tecnicos.filter(t => t.name == "GENERAL")[0];
          this.concepto = 'Tareas varias';
          this.aRealizar = 'Tareas varias';
        }else{ //si se cierra la ventana de editar restauramos a los valores que habia antes de abrir el dialogo
          this.parteCreado = this.tecnicos.filter(tecnico => tecnico.name === this.partes[0].user.name)[0];
          this.concepto = this.partes[0].concepto;
          this.aRealizar = this.partes[0].realizar;
        }
      },
      eliminarParte(){
        this.partes.shift(); //elimino el parte creado
        if(typeof(this.idParteSeleccionado) === 'string'){ //si al eliminar el parte es el que teniamos selecionado vaciamos la variable idParteSeleccionado
          this.idParteSeleccionado = this.timer.parteInicial;
        }
        this.botonNuevoParte= true; //activo el boton
        this.parteCreado = this.tecnicos.filter(t => t.name == "GENERAL")[0];
        this.concepto = 'Tareas varias';
        this.aRealizar= 'Tareas varias';
      },
      esNuevo(idParte){
        if(typeof(idParte) === 'string'){
          return true;
        }
        return false;
      },
      calcularTiempoTotal(){
        let inicio = this.timer.inicioTimerFD.split(':');
        let fin = this.timer.finTimerFD.split(':');
        let fInicio = new Date();
        let fFinal = new Date();
    
        fInicio.setHours(inicio[0], inicio[1], '00');
        fFinal.setHours(fin[0], fin[1], '00');

        fInicio.setHours(fFinal.getHours() - fInicio.getHours(), fFinal.getMinutes() - fInicio.getMinutes());

        this.timer.tiempoTotalFD = (fInicio.getHours() < 10 ? '0'+fInicio.getHours() : fInicio.getHours())+':' +(fInicio.getMinutes() < 10 ? '0'+fInicio.getMinutes() : fInicio.getMinutes());
        let tiempoTotal = this.timer.tiempoTotalFD.split(':');

        if(this.timer.invalido == true && (tiempoTotal[0] > 0 || tiempoTotal[1] > 15)){
          this.timer.invalido = false;
        }
      },
      comprobarTiempo(valor) {
        if (valor) { // Al marcar el check de desplazamiento se verifica el tiempo de la acción. Si la acción es inferior a 1 hora, se marca automáticamente el check de asistencia mínima.
          let tiempoTotal = this.timer.tiempoTotalFD.split(':');
          if (tiempoTotal[0] < 1 && tiempoTotal[0] >= 0) {
            this.masOpciones.asistencia_minima = true;
          }else{
            this.masOpciones.asistencia_minima = false;
          }
        }else{
          this.masOpciones.asistencia_minima = false;
        }
      },
      siguienteImputarTodos(){ //RECUPERO TODOS LOS DATOS NECESSRIOS PARA EL SIGUIENTE TIMER DE IMPUTAR TODOS
        this.setCargarDatosDialog(true);
      },
      async comprobarDatos(){
        this.setLoading(true);
        try {          
          //obrener comercial de referencia
          let comercialReferencia = this.comerciales.filter(item => item.email === this.timer.comercialCliente);

          // obtener responsable de cuenta
          let respuestaResponsable = await axios.get(`/api/tecnicosCliente?cliente_id=${this.timer.idCliente}`);
          this.responsable_id = (this.tecnicos.find(tecnico => tecnico.email === respuestaResponsable.data[0].responsableCuenta))?.id;
          if(this.delegaciones.length == 0 || comercialReferencia.length == 0 || this.responsable_id === undefined){
            this.setSnackbar({
              tipo: 'warning',
              mensaje: 'Para poder crear el parte es necesario que el cliente tenga asignado un comercial, una delegación y un responsable de cuenta.'
            });
          }else{
            this.idComercialReferencia = comercialReferencia[0].id;
            this.dialogCrearEditarParte = true;
          }
          this.setLoading(false);
        } catch (error) {
          this.setLoading(false);
          this.setSnackbar({
            tipo: 'error',
            mensaje: 'Error. No se han podido recuperar los datos necesarios para crear el parte'
          });
        }
      },
      verificarSiContieneContrato(){
        if(!this.contratoSeleccionado.ambitos.some(ambito => ambito.id === this.ambito)){
          this.ambito = '';
        }
      },
      accionAlImputar() {
        if(this.masOpciones.desplazamiento) {
          this.dialogAvisoMateriales = true;
        }
        else {
          this.imputar();
        }
      },
      insertarComentario(comentarios){
        if(this.comentariosFD === null) this.comentariosFD = ''
        if(this.comentariosFD.length > 0) this.comentariosFD += '\n'
        comentarios.forEach((comentario, index, comentarios) => {
          this.comentariosFD += comentario.texto
          if(index < comentarios.length-1){
            this.comentariosFD += '\n'
          }
        });
        this.dialogComentariosGuardados = false
      },
      decimalToHHMM (decimal) {
        return `${Math.floor(decimal)} horas ${Math.round((decimal - Math.floor(decimal)) * 60)} minutos`
      },
      dateToYMD(date) {
        return date.toISOString().substr(0, 10);
      }
    },
    watch: {
      fecha (val) {
        this.fechaFormateada = this.formatDate(this.fecha)
      },
      cargarDatosDialog(){
        if(this.cargarDatosDialog == false){//Cuando ya ha cargado todos los datos
          this.inicializarDatos();
        }
      },
      "timer.inicioTimerFD"(){
        this.horasInformadas = null
      },
      "timer.finTimerFD"(){
        this.horasInformadas = null
      }
    },
    computed: {
      ...mapState('arditimer', ['timers', 'dialog', 'idTimerActivo', 'imputarTodos', 'cargarDatosDialog']),        
      ...mapState("login", ["authUser"]),
      ...mapState("resumen", ["esMoroso"]),
      delegacionParteSeleccionado(){
        let parteSeleccionado = this.partes.find(parte => parte.id === this.idParteSeleccionado);
        let delegacionParte = this.delegaciones.find(delegacion => delegacion.delegacionId === parteSeleccionado?.delegacion_id);
        if (delegacionParte !== undefined){
          return  delegacionParte.direccion;
        }else{
          return this.delegaciones[0].direccion;
        }
      },
      errorHorasInformadas () {
        if (this.$v.horasInformadas.$dirty){ //comprobación de si se ha hecho clic en el campo
          if (this.$v.horasInformadas.$invalid){ //comprobación de si el campo esta vacio 
            return 'Introduce el tiempo que quieres imputar a la acción';
          }
        }
      },
      errorComentarios () {
        if (this.$v.comentariosFD.$dirty){ //comprobación de si se ha hecho clic en el campo
          if (this.$v.comentariosFD.$invalid){ //comprobación de si el campo esta vacio 
            return 'Introduce los comentarios correspondientes';
          }
        }
      },
      errorContratoSeleccionado () {
        if (this.$v.contratoSeleccionado.$invalid){ //comprobación de si el campo esta vacio 
          return "Selecciona un contrato";
        }
      },
      errorAmbito () {
        if (this.$v.ambito.$invalid){ //comprobación de si el campo esta vacio 
          return "Selecciona un ambito";
        }
      },
      contratosActivos() {
        // Verifica si el parte tiene restricción por tipo de contrato. Si tiene restricción, solo deja seleccionar ese contrato (a parte de facturable, no facturable...)
        // Si no tiene restricción, devuelve los contratos del cliente
        let parte = this.partes.filter(p => p.id == this.idParteSeleccionado)[0];
        if(parte){
          // console.log(this.contratos);
          let contratosFiltrados = this.contratos.filter((contrato) =>
            parte.tipoParte_id === null ||
            parte.tipoParte_id === undefined
              ? contrato.activo === true && contrato.id !== 7
              : contrato.id === parte.tipoParte_id || contrato.siempreVisible);
              
          if(parte.tipoParte_id === null || parte.tipoParte_id === undefined){
            this.restriccionContrato = false;
          }else{
            this.restriccionContrato = true;
          }
          // Si el id del contrato seleccionado no está en el array de contratos filtrados, vaciamos la variable para que el usuario tenga que seleccionar el nuevo contrato
          if(!contratosFiltrados.some(c => c.id === this.contratoSeleccionado.id)){
            this.contratoSeleccionado = contratosFiltrados.find(contrato => contrato.id === parte.tipoParte_id);
            if(this.contratoSeleccionado){
              this.ambito = this.contratoSeleccionado.ambitos[0].id;
            }else {
              this.contratoSeleccionado = {};
            }
          }
          return contratosFiltrados;
        }
        // Si no tiene parte seleccionado, devuelve los contratos del cliente
        return this.contratos;
      },
      horasReales(){
        let horasReales = this.timer.inicioTimerFD && this.timer.finTimerFD ? calcularHorasReales(this.timer.inicioTimerFD, this.timer.finTimerFD, this.masOpciones.abono) : null
        if(this.horasInformadas === null) this.horasInformadas = horasReales
        return horasReales
      }
    }
  }
</script>